import { AriaDescriber, FocusMonitor } from '@angular/cdk/a11y';
import { Directionality } from '@angular/cdk/bidi';
import { Overlay, ScrollDispatcher } from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';
import {
  AfterViewInit,
  Directive,
  ElementRef,
  Inject,
  Input,
  NgZone,
  OnDestroy,
  Optional,
  ViewContainerRef,
} from '@angular/core';
import {
  MAT_LEGACY_TOOLTIP_DEFAULT_OPTIONS as MAT_TOOLTIP_DEFAULT_OPTIONS,
  MAT_LEGACY_TOOLTIP_SCROLL_STRATEGY as MAT_TOOLTIP_SCROLL_STRATEGY,
  MatLegacyTooltip as MatTooltip,
  MatLegacyTooltipDefaultOptions as MatTooltipDefaultOptions,
} from '@angular/material/legacy-tooltip';

@Directive({ selector: '[cslOverflowTooltip]', exportAs: 'cslOverflowTooltip' })
export class OverflowTooltipDirective extends MatTooltip implements AfterViewInit, OnDestroy {
  @Input()
  get cslOverflowTooltip() {
    return this.message;
  }
  set cslOverflowTooltip(value: string) {
    this.message = value;
  }

  observer: MutationObserver;

  constructor(
    private elementRef: ElementRef,
    overlay: Overlay,
    scrollDispatcher: ScrollDispatcher,
    viewContainerRef: ViewContainerRef,
    ngZone: NgZone,
    platform: Platform,
    ariaDescriber: AriaDescriber,
    focusMonitor: FocusMonitor,
    @Inject(MAT_TOOLTIP_SCROLL_STRATEGY) scrollStrategy: any,
    @Optional() dir: Directionality,
    @Optional()
    @Inject(MAT_TOOLTIP_DEFAULT_OPTIONS)
    defaultOptions: MatTooltipDefaultOptions,
    @Inject(DOCUMENT) _document: any
  ) {
    super(
      overlay,
      elementRef,
      scrollDispatcher,
      viewContainerRef,
      ngZone,
      platform,
      ariaDescriber,
      focusMonitor,
      scrollStrategy,
      dir,
      defaultOptions,
      _document
    );
  }

  override ngAfterViewInit() {
    const element = this.elementRef.nativeElement;

    this.observer = new MutationObserver(() => {
      this.disabled = !(element.offsetWidth < element.scrollWidth || element.offsetHeight < element.scrollHeight);
    });

    const config = { attributes: true, childList: true, characterData: true, subtree: true };
    this.observer.observe(this.elementRef.nativeElement, config);

    super.ngAfterViewInit();
  }

  override ngOnDestroy(): void {
    this.observer.disconnect();

    super.ngOnDestroy();
  }
}
